// extracted by mini-css-extract-plugin
module.exports = {"heart":"Heart_heart__1qaz-","label":"Heart_label__3qnu0"};